import fortmaticLib from "../lib/fortmatic";
import web3Lib from "../lib/web3";

const Account = ({ fortmatic, web3 }, args) => {
  const getAddress = async () => {
    const accounts = await web3.eth.getAccounts();
    if (!accounts.length) throw new Error("No account found.");
    const address = accounts[0];
    return { address };
  };

  /* istanbul ignore next */
  const getPubKey = async () => {};

  /* istanbul ignore next */
  const signTransaction = async (rawTx) => {
    return new Promise((resolve, reject) => {
      web3.eth.sendTransaction(rawTx, (err, txHash) => {
        if (err) return reject(err);
        resolve({ txHash });
      });
    });
  };

  const sign = async (message) => {
    const { address } = await getAddress();
    const signature = await web3.eth.personal.sign(message, address);
    return signature;
  };

  /* istanbul ignore next */
  const verifySignature = async (message, signature) => {};

  return {
    getAddress,
    getPubKey,
    sign,
    signTransaction,
    verifySignature,
  };
};

const Backend = ({ fortmatic, web3 }) => {
  const genAccount = async (args) => Account({ fortmatic, web3 }, args);

  const getAccount = async (args) => genAccount(args);

  const cleanUp = async () => {
    return fortmatic.user.logout();
  };

  return {
    getAccount,
    cleanUp,
  };
};

Backend.create = async ({ fortmaticOptions = {} } = {}) => {
  const fortmatic = new fortmaticLib.Fortmatic(
    fortmaticOptions.apiKey,
    fortmaticOptions.network
  );
  if (fortmaticOptions.shouldCleanUp) {
    fortmatic.user.logout();
  }
  const web3 = new web3Lib.Web3(fortmatic.getProvider());
  return Backend({ fortmatic, web3 });
};

export default Backend;
